import { render, staticRenderFns } from "./FullscreenItem.vue?vue&type=template&id=4db7e1fc&scoped=true"
import script from "./FullscreenItem.vue?vue&type=script&lang=js"
export * from "./FullscreenItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db7e1fc",
  null
  
)

export default component.exports